import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What Settings > Custom Fields still reads from the workspace: the open setting and tab (also set from the URL and from Add client), the custom fields and labels lists other screens use, their loaders, and the row-menu / filter open flags closed by the workspace's outside-click handler.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmSettingsCustomFieldsHost = Pick<
  PmWorkspaceComponent,
  | 'activeCustomFieldTab'
  | 'activeSettingItem'
  | 'customFieldFilterPopoverOpen'
  | 'customFieldRowActionsOpenId'
  | 'customFieldSettingsError'
  | 'customFieldSettingsLoading'
  | 'customFields'
  | 'customLabelsDraft'
  | 'dropdownOptions'
  | 'effectiveDirectoryParentUserId'
  | 'extraCustomLabelsDraft'
  | 'loadCustomFieldsSettings'
  | 'loadCustomLabelsSettings'
  | 'newOptionValue'
  | 'pmCustomLabels'
>;

export const PM_SETTINGS_CUSTOM_FIELDS_HOST = new InjectionToken<PmSettingsCustomFieldsHost>('PmSettingsCustomFieldsHost');
